import { render, staticRenderFns } from "./OrganizationTeam.vue?vue&type=template&id=2eaf7cce&scoped=true&"
import script from "./OrganizationTeam.vue?vue&type=script&lang=js&"
export * from "./OrganizationTeam.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationTeam.vue?vue&type=style&index=0&id=2eaf7cce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaf7cce",
  null
  
)

export default component.exports